// Smooth scrolling

document.addEventListener('DOMContentLoaded', () => {
  // Attach to any anchor links
  document.querySelectorAll('a[href^="#"], a[href^="/#"]')
    // Remove links that don't actually link to anything
    .forEach((link) => {
      if (link.getAttribute('href') !== '#' && link.getAttribute('href') !== '#0') {
        link.addEventListener('click', (e) => {
          let id = link.getAttribute('href');
          if ((!id || id.startsWith('/') && window.location.pathname !== '/') || id === '#mainContent') {
            return;
          }

          e.preventDefault();

          if (id.startsWith('/')) {
            id = id.slice(1);
          }

          const target = document.querySelector(id);

          smoothScroll(target);
        });
      }
    });

  function smoothScroll(elem) {
    if (!elem) {
      return;
    }

    const navHeight = document.getElementById('js-nav')?.offsetHeight ?? 0;
    const targetPosition = elem.getBoundingClientRect().top + window.pageYOffset - navHeight;
    const startPosition = window.pageYOffset;
    const distance = targetPosition - startPosition;
    const duration = 800;
    let start = null;

    const step = (timestamp) => {
      if (!start) {
        start = timestamp;
      }

      //@ts-ignore
      const progress = timestamp - start;
      const progressRatio = Math.min(progress / duration, 1);
      window.scrollTo(0, startPosition + distance * progressRatio);
      if (progress < duration) {
        window.requestAnimationFrame(step);
      }
    };

    window.requestAnimationFrame(step);
  }
});
